<template>
  <div>
    <div class="warn-content">
      <div v-for="(item,index) in itemList" class="warn-content-detail" :key="index">
        <div class="warn-content-name">
          {{item.lowerCH}}
        </div>
        <div class="warn-content-input">
          <el-input placeholder=0 type='number' v-model="item.low"></el-input>
        </div>
        <div class="warn-content-name">
          {{item.upperCH}}
        </div>
        <div class="warn-content-input">
          <el-input  type='number' placeholder=0 v-model="item.up"></el-input>
        </div>
      </div>
    </div>
    <div class="warn-bottom">
      <div class="warn-bottom-bottomList">
        <div class="warn-bottom-btn" @click="btnOK">{{$t("mobileConfirm")}}</div>
        <div class="warn-bottom-btn" @click="btnCancel">{{$t("mobileCancel")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {clientInfo, getAttributesClient, getCredentials} from "../untils/api/home";

  export default {
    name: 'warnData',
    components: {},
    data() {
      return {
        itemList: [],
        deviceInfo: {},
        oldKeyInfo: '',
        map1: null,
        map2: null,
        originalList: null
      }
    },

    methods: {
      /**
       * 传递最新遥测，获取警告类型
       * @param deviceId
       * @param response
       */
      getKeysInfos(deviceId,response) {
        let strKey = response.join(",");
        if(this.oldKeyInfo !== strKey ||  this.deviceInfo.id !== deviceId.id){
          this.deviceInfo = deviceId;
          this.oldKeyInfo = strKey;
          this.itemList = [];
          setTimeout(() => {
            for(let i = 0; i < response.length; i++) {
              let warnJson = {};
              warnJson.upperCH = this.$t(response[i]).split(',')[0] + this.$t("mobileUp");
              warnJson.upperEN = response[i] + '_up';
              warnJson.up = this.map1.get(response[i]) === undefined ? "" : this.map1.get(response[i]);
              warnJson.lowerCH = this.$t(response[i]).split(',')[0] + this.$t("mobileLow");
              warnJson.lowerEN = response[i] + '_low';
              warnJson.low = this.map2.get(response[i]) === undefined ? "" : this.map2.get(response[i]);
              this.itemList.push(warnJson);
            }
            this.originalList = JSON.parse(JSON.stringify(this.itemList));
          },15)
        }

      },

      /**
       * 根据选中的值获取设备数据
       * @param deviceId
       */
      getMobileCredentialsInfo(deviceId) {
        getCredentials(deviceId).then(response => {
         this.getMobileClientInfos(response.credentialsId)
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 获取客户端遥测数据上下限值
       * @param credentialsId
       */
      getMobileClientInfos(credentialsId){
        this.map1 = null;
        this.map2 = null;
        this.map1 = new Map();
        this.map2 = new Map();
        getAttributesClient(credentialsId).then(response => {
          for(let obj in response.client){
            if(obj.substring(obj.length - 3) === '_up'){
              this.map1.set(obj.substring(0,obj.length - 3),response.client[obj]);
            } else if(obj.substring(obj.length - 4) === '_low'){
              this.map2.set(obj.substring(0,obj.length - 4),response.client[obj]);
            }
          }
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 确定按钮
       */
      btnOK(){
        let _this = this;
        let upLowList = [];//设置警告集合
        let flg = true;//上限是否等于下限的标识符
        for(let i = 0; i < this.itemList.length; i++){
          //将上限值转化为数字类型
          this.itemList[i].up === "" ? this.itemList[i].up = 0 : this.itemList[i].up = parseFloat(this.itemList[i].up);
          //将下限值转化为数字类型
          this.itemList[i].low === "" ? this.itemList[i].low = 0 : this.itemList[i].low = parseFloat(this.itemList[i].low);
          if(parseFloat(this.itemList[i].low) < parseFloat(this.itemList[i].up)
            && (parseFloat(this.itemList[i].low) !== parseFloat(this.originalList[i].low) || parseFloat(this.itemList[i].up) !== parseFloat(this.originalList[i].up))){//下限值低于上限值
            let param = {};
            //赋值
            param[this.itemList[i].upperEN] = parseFloat(this.itemList[i].up);
            param[this.itemList[i].lowerEN] = parseFloat(this.itemList[i].low);
            //添加到集合
            upLowList.push(param);
          } else if(parseFloat(this.itemList[i].low) > parseFloat(this.itemList[i].up)){ //下限值大于上限值
            flg = false;
            //提示信息
            if(localStorage.getItem('locale') === 'en-US'){
              setTimeout(function () {
                _this.$message({
                  showClose: true,
                  type: "warning",
                  message: _this.itemList[i].lowerCH.substring(0, _this.itemList[i].lowerCH.length -4) + _this.$t("mobileMessage2")
                });
              }, 1);
            } else {
              setTimeout(function () {
                _this.$message({
                  showClose: true,
                  type: "warning",
                  message: _this.itemList[i].lowerCH.substring(0, _this.itemList[i].lowerCH.length -2) + _this.$t("mobileMessage2")
                });
              }, 1);
            }

            this.itemList[i].up = this.originalList[i].up;
            this.itemList[i].low = this.originalList[i].low;
          } else if(parseFloat(this.itemList[i].low) === parseFloat(this.itemList[i].up)) {//上限值等于下限值
            this.itemList[i].up = this.originalList[i].up;
            this.itemList[i].low = this.originalList[i].low;
          }
        }
        localStorage.setItem('upLowList',null);
        if(upLowList.length > 0){//存在上下限值，保存到数据库
          localStorage.setItem('upLowList',JSON.stringify(upLowList));
          this.originalList = JSON.parse(JSON.stringify(this.itemList));
          //获取访问令牌
          this.getClientToken(upLowList);
        } else if(flg) {
          this.$message({
            showClose: true,
            type: "warning",
            message: this.$t("mobileMessage1")
          });
        }
      },

      /**
       * 取消清空
       */
      btnCancel() {
        for(let i = 0; i < this.itemList.length; i++){
          this.itemList[i].up = this.originalList[i].up;
          this.itemList[i].low = this.originalList[i].low;
        }
      },

      /**
       *
       * @param upLowList
       */
      getClientToken(upLowList) {
        getCredentials(this.deviceInfo.id).then(response => {
          //向客户端传值
          this.setUpLowClient(response.credentialsId,upLowList)
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 向客户端传值
       * @param credentialsId
       * @param upLowList
       */
      setUpLowClient(credentialsId,upLowList){
        for(let i = 0; i < upLowList.length; i++) {
          clientInfo(credentialsId, upLowList[i]).then(response => {
            if(response === ''){
            } else {//上传失败
              this.$message({
                showClose: true,
                type: "warning",
                message: this.$t("mobileMessage3")
              });
            }
          }).catch(error => {
            console.log("error",error)
          })
        }
      }
    }
  }
</script>

<style lang="less">
  @media screen and (max-width: 500px) {
    .el-message--warning {
      font-size: 5vw;
      width: 75%;

      .el-message__content{
        font-size: 4vw;
      }
    }
  }
</style>

<style lang="less" scoped>
  @media screen and (max-width: 500px) {
    .warn-content {
      width: 100%;
      overflow: auto;
      top: 1%;
      position: absolute;
      bottom: 9vw;
    }

    .warn-content-detail {
      width: 95%;
      height: 15vw;
      display: flex;
      justify-content: space-between;
      font-size: 3.5vw;
      border: 1px outset #314963;
      background-color: #314963;
      border-radius: 50px;
      margin-bottom: 2%;
      margin-left: 2.5%;
    }

    .warn-content-name {
      width: 25%;
      display: flex;
      align-items: center;
      padding-left: 2vw;
    }

    .warn-content-input {
      width: 25%;
      display: flex;
      align-items: center;
      text-align: center;
    }

    .warn-bottom {
      height: 9vw;
      position: absolute;
      bottom: 0;
      width: 100%;
      background-color: #314963;
    }

    .warn-bottom-bottomList {
      display: flex;
      justify-content: space-between;
      height: 9vw;
      width: 30%;
      margin-left: 35%;
    }

    .warn-bottom-btn {
      background-color: #345A7C;//#376D91
      border: 1px outset #345A7C;
      height: 7vw;
      width: 70%;
      text-align: center;
      font-size: 3.5vw;
      line-height: 7vw;;
      color: #ffffff;
      border-radius: 30px;
      margin-top:1vw;
      margin-left: 2vw;
    }

    /deep/ .el-input__inner {
      height: 6vw;
      width: 80%;
      font-size: 4vw;
      border-radius: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/warnData.vue